import { getDataFromLocalStorage } from '@/helpers/helpers'
import { externalServices } from '@/plugins/axios'
import { AxiosRequestConfig } from 'axios'

export class SyncfusionService {
  constructor() {}

  exportToPdf(fileData: Blob) {
    const url = `${process.env.VUE_APP_SYNCFUSION_PDF_API}/export`
    const config: AxiosRequestConfig = {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      responseType: 'blob'
    }
    const formData: FormData = new FormData()
    formData.append('files', fileData)
    return externalServices.post(url, formData, config)
  }

  importTemplate(formData: FormData) {
    const authData = getDataFromLocalStorage('authData')
    const accessToken = authData?.accessToken || ''
    const url = `${process.env.VUE_APP_SYNCFUSION_TEMPLATE_API}import`
    const config: AxiosRequestConfig = {
      headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${accessToken}` }
    }

    return externalServices.post(url, formData, config)
  }
}
